<!-- 合同审批-->
<template>
  <div class="wrapper">
    <div class="navCard">
      <a
        v-for="(item, index) in tabs"
        :key="index"
        :class="[activeTab == index ? 'active' : '']"
        @click="changeTab(index)"
        >{{ item.title }}<span v-if="activeTab == index"></span
      ></a>
    </div>
    <div class="mainCard">
      <div class="mainBox">
        <div class="card">
          <div class="cardTitle">
            <h3>基本信息</h3>
            <span>{{
              myDataObj.approStatus | itemFilter('approve_status', allSelect)
            }}</span>
          </div>
          <p>
            <label>审核类型</label>
            <span>{{ myDataObj.groupName }}</span>
          </p>
          <p>
            <label>发起人</label>
            <span>{{ myDataObj.promoterName }}</span>
          </p>
          <p>
            <label>发起时间</label>
            <span>{{ myDataObj.promoterTime }}</span>
          </p>
          <p>
            <label>审批时长</label>
            <span>{{ myDataObj.diff | timeFilter }}</span>
          </p>
        </div>
        <div class="card">
          <div class="cardTitle">
            <h3>合同基本信息</h3>
            <a v-if="micromessengerUserAgent" @click="jumpToXcxContractDetailFn">查看合同 ></a>
          </div>
          <div
            class="cardMain"
            v-if="
              !(myDataObj.bizFlag == 'HTBGN' || myDataObj.bizFlag == 'HTTZU')
            "
          >
            <p>
              <label>租客信息</label>
              <span>{{ contractDetail.merchantName }}</span>
            </p>
            <div class="box">
              <p>
                <label>合同类型</label>
                <span>{{
                  contractDetail.collection
                    | itemFilter('contract_collection', allSelect)
                }}</span>
              </p>
              <p>
                <label>新签/续签</label>
                <span>{{
                  contractDetail.contRenew | itemFilter('cont_renew', allSelect)
                }}</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>条款类型</label>
                <i
                  v-if="
                    contractDetail.conType == 1 || contractDetail.conType == 3
                  "
                  class="zu"
                  >租</i
                >
                <i
                  v-if="
                    contractDetail.conType == 2 || contractDetail.conType == 3
                  "
                  class="wu"
                  >物</i
                >
              </p>
              <p>
                <label>跟进人</label>
                <span>{{ contractDetail.traceUserName }}</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>起始日期</label>
                <span>{{ contractDetail.startDate }}</span>
              </p>
              <p>
                <label>到期日期</label>
                <span>{{ contractDetail.endDate }}</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>租期</label>
                <span>{{ contractDetail.period }}</span>
              </p>
              <p>
                <label>违约金比例</label>
                <span>{{ contractDetail.latefeeRate || '-' }}%</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>租赁保证金</label>
                <span>{{ contractDetail.rentBailAmount }}元</span>
              </p>
              <p>
                <label>物业保证金</label>
                <span>{{ contractDetail.propertyBailAmount }}元</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>租赁面积</label>
                <span>{{ contractDetail.rentArea }}㎡</span>
              </p>
              <p>
                <label>租金合计</label>
                <span>{{ contractDetail.rentAmount }}元</span>
              </p>
            </div>
            <div class="box">
              <p>
                <label>物业面积</label>
                <span>{{ contractDetail.propertyArea }}㎡</span>
              </p>
              <p>
                <label>物业费合计</label>
                <span>{{ contractDetail.propertyAmount }}元</span>
              </p>
            </div>
            <div
              class="box"
              v-for="item in contractDetail.keywordMapList"
              :key="item.keywords"
            >
              <p>
                <label>{{ item.keywords }}</label>
                <span>{{ item.keywordValue }}</span>
              </p>
            </div>
          </div>
          <div class="changeCard" v-if="myDataObj.bizFlag == 'HTBGN'">
            <p>
              <label>合同编号</label>
              <span>{{contractDetailInfo.bsContractHeaderVo.contCode ? contractDetailInfo.bsContractHeaderVo.contCode : '-'}}</span>
            </p>
            <p>
              <label>变更类型</label>
              <span v-if="contractDetailInfo.bsContractHeaderVo.opType == 6">特殊变更</span>
              <span v-if="contractDetailInfo.bsContractHeaderVo.opType == 7">条款变更</span>
            </p>
          </div>
          <div v-if="myDataObj.bizFlag == 'HTTZU'">
            <p>
              <label>合同编号</label>
              <span>{{
                contractDetailData.bsContractHeaderVo.contCode
                  ? contractDetailData.bsContractHeaderVo.contCode
                  : '-'
              }}</span>
            </p>
            <p>
              <label>退租企业</label>
              <span>{{
                contractDetailData.bsContractHeaderVo.merchantName
              }}</span>
            </p>
            <div class="terminateCard">
              <div class="terminateBox">
                <label>退租生效日</label>
                <span>{{
                  contractDetailData.bsContractHeaderVo.cancelEffectDate
                }}</span>
              </div>
              <div class="terminateBox">
                <label>工商地址变更最迟日期</label>
                <span>{{
                  contractDetailData.bsContractHeaderVo.comAddressChangeDate
                }}</span>
              </div>
              <div class="terminateBox">
                <label>签订日期</label>
                <span>{{
                  contractDetailData.bsContractHeaderVo.cancelSignDate
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'HTTZU'">
          <div class="cardTitle">
            <h3>费用结算</h3>
          </div>
          <div class="totalCostCard">
            <div class="totalCostTitle">
              <span class="circle">计费周期</span>
              <span class="type">类型</span>
              <span class="should">需收/付/退</span>
              <span class="account">结算金额</span>
            </div>
            <div class="totalCostBox">
              <p
                v-for="(item, index) in contractDetailData.breakFeeGatherVoList"
                :key="index"
              >
                <span class="circle"
                  >{{ item.startDate }} - {{ item.endDate }}</span
                >
                <span class="type">{{
                  item.feeCode | itemFeeCodeFilter(self_fee_code)
                }}</span>
                <span class="should">{{
                  item.retreat == '1' ? '收' : item.retreat == '2' ? '付' : '退'
                }}</span>
                <span
                  class="account"
                  :style="{
                    color:
                      item.retreat == '1'
                        ? 'rgba(0,0,0,0.8)'
                        : 'rgba(245,70,76,1)'
                  }"
                  >{{ item.money }}</span
                >
              </p>
            </div>
            <div class="sumCard">
              <h4 v-if="breakFeeGatherTotal >= 0">总计需收：</h4>
              <h4 v-else>总计需退：</h4>
              <span>{{ breakFeeGatherTotal |keepTwoDecimal }}</span>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'HTTZU'">
          <div class="cardTitle">
            <h3>退租原因</h3>
          </div>
          <div
            class="terminateReasons"
            v-if="contractDetailData.bsContractHeaderVo.reasons"
          >
            <span
              v-for="item in contractDetailData.bsContractHeaderVo.reasons.split(
                ','
              )"
              :key="item"
            >
              <template v-if="item == 1">到期退租,</template>
              <template v-if="item == 2">公司扩张,</template>
              <template v-if="item == 3">租金问题,</template>
              <template v-if="item == 4">物业服务,</template>
              <template v-if="item == 5">交通问题,</template>
              <template v-if="item == 6">硬件设施,</template>
              <template v-if="item == 7">经营不利,</template>
              <template v-if="item == 8">卫生状况,</template>
              <template v-if="item == 9">其它原因,</template>
            </span>
            <div>{{ contractDetailData.bsContractHeaderVo.remark }}</div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'HTBGN'">
          <div class="cardTitle">
            <h3>基本信息对比</h3>
            <div class="changeTitle">
              <a :class="!changeIndex ? 'activeChangeTitle' : ''" @click="changeIndex = 0">变更后</a>
              <a :class="changeIndex ? 'activeChangeTitle' : ''" @click="changeIndex = 1">变更前</a>
            </div>
          </div>
          <div class="changeCard">
            <div v-if="changeIndex == 0">
              <p>
                <label>生效日期</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.effectDate}}</span>
              </p>
              <p>
                <label>租客信息</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.merchantName}}</span>
              </p>
              <div class="box">
                <p>
                  <label>租赁面积</label>
                  <span>{{contractDetailInfo.bsContractHeaderVo.rentArea}}㎡</span>
                </p>
                <p>
                  <label>物业面积</label>
                  <span>{{contractDetailInfo.bsContractHeaderVo.propertyArea}}㎡</span>
                </p>
              </div>
              <p>
                <label>租期</label>
                <span>
                  {{contractDetailInfo.bsContractHeaderVo.startDate}} - 
                  {{contractDetailInfo.bsContractHeaderVo.endDate}} => 
                  {{contractDetailInfo.bsContractHeaderVo.period}}
                </span>
              </p>
              <p>
                <label>跟进人</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.traceUserName}}</span>
              </p>
              <p>
                <label>违约金比例</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.latefeeRate || '--'}}%</span>
              </p>
              <p>
                <label>条款类型</label>
                <span v-if="contractDetailInfo.bsContractHeaderVo.conType == 1">
                  <span style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">租赁</span>
                </span>
                <span v-if="contractDetailInfo.bsContractHeaderVo.conType == 2">
                  <span style="color: #1890ff; background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">物业</span>
                </span>
                <span v-if="contractDetailInfo.bsContractHeaderVo.conType == 3">
                  <span style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">租赁</span>
                  <span style="color: #1890ff; background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">物业</span>
                </span>
              </p>
              <p>
                <label>合同类型</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.collection | itemFilter('contract_collection', allSelect)}}</span>
              </p>
              <p>
                <label>合同属性</label>
                <span>{{contractDetailInfo.bsContractHeaderVo.contRenew | itemFilter('cont_renew', allSelect)}}</span>
              </p>
              <p>
                <label>房源</label>
                <span style="display: flex; flex-direction: column;">
                  <span v-for="(item,i) in contractDetailInfo.bsContractSpaceList" 
                        style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-bottom: 4px;">
                    {{item.buildName}} | {{item.spaceName}}
                  </span>
                </span>
              </p>
            </div>
            <div v-if="changeIndex == 1">
              <p>
                <label>生效日期</label>
                <span>{{'--'}}</span>
              </p>
              <p>
                <label>租客信息</label>
                <span>{{contractDetailInfoOld.bsContractHeaderVo.merchantName}}</span>
              </p>
              <div class="box">
                <p>
                  <label>租赁面积</label>
                  <span>{{contractDetailInfoOld.bsContractHeaderVo.rentArea}}㎡</span>
                </p>
                <p>
                  <label>物业面积</label>
                  <span>{{contractDetailInfoOld.bsContractHeaderVo.propertyArea}}㎡</span>
                </p>
              </div>
              <p>
                <label>租期</label>
                <span>
                  {{contractDetailInfoOld.bsContractHeaderVo.startDate}} - 
                  {{contractDetailInfoOld.bsContractHeaderVo.endDate}} => 
                  {{contractDetailInfoOld.bsContractHeaderVo.period}}
                </span>
              </p>
              <p>
                <label>跟进人</label>
                <span>{{contractDetailInfoOld.bsContractHeaderVo.traceUserName}}</span>
              </p>
              <p>
                <label>违约金比例</label>
                <span>{{contractDetailInfoOld.bsContractHeaderVo.latefeeRate || '--'}}%</span>
              </p>
              <p>
                <label>条款类型</label>
                <span v-if="contractDetailInfoOld.bsContractHeaderVo.conType == 1">
                  <span style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">租赁</span>
                </span>
                <span v-if="contractDetailInfoOld.bsContractHeaderVo.conType == 2">
                  <span style="color: #1890ff; background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">物业</span>
                </span>
                <span v-if="contractDetailInfoOld.bsContractHeaderVo.conType == 3">
                  <span style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">租赁</span>
                  <span style="color: #1890ff; background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px; padding: 1px 7px; margin-right: 8px;">物业</span>
                </span>
              </p>
              <p>
                <label>合同类型</label>
                <span>{{contractDetailInfoOld.bsContractHeaderVo.collection | itemFilter('contract_collection', allSelect)}}</span>
              </p>
              <p>
                <label>合同属性</label>
                <span>{{contractDetailInfoOld.bsContractHeaderVo.contRenew | itemFilter('cont_renew', allSelect)}}</span>
              </p>
              <p>
                <label>房源</label>
                <span style="display: flex; flex-direction: column;">
                  <span v-for="(item,i) in contractDetailInfoOld.bsContractSpaceList" 
                        style="color: rgba(0, 0, 0, 0.65); background: #fafafa; border: 1px solid #d9d9d9; border-radius: 4px; padding: 1px 7px; margin-bottom: 4px;">
                    {{item.buildName}} | {{item.spaceName}}
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'HTBGN'">
          <div class="cardTitle">
            <h3>应收计划对比</h3>
            <div class="changeTitle">
              <a :class="!changeIndexDetail ? 'activeChangeTitle' : ''" @click="changeIndexDetailFn(0)">变更后</a>
              <a :class="changeIndexDetail ? 'activeChangeTitle' : ''" @click="changeIndexDetailFn(1)">变更前</a>
            </div>
          </div>
          <div class="changeCard" style="font-size: 14px;">
            <!-- 变更后 -->
            <div v-if="changeIndexDetail == 0" style="padding: 0 16px;">
              <!-- 租赁条款 -->
              <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList.length">
                <ul style="display: flex; height: 30px; line-height: 30px; margin-top: 20px;">
                  <li v-for="(item_i,i) in contractDetailInfo.bsChargeDetailVo.rentClauseDetailList"
                      style="border: 1px solid #d9d9d9; padding: 0 6px;" 
                      v-bind:style="{backgroundColor: activeDetailRentTab == i ? '#4f84ff' : 'unset',
                                     color: activeDetailRentTab == i ? '#FFF' : 'unset',
                                     borderColor: activeDetailRentTab == i ? '#4f84ff' : '#d9d9d9',}"
                      @click="activeDetailRentTabFn(i)">
                    租赁条款{{i+1}}
                  </li>
                </ul>
                <!-- 租赁保证金押金 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">租赁保证金押金</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[0] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox1' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;"> - </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 租金 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">
                      {{contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1][0].clauseTypeName}}
                    </h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[1] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox2' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '2000'">
                              <span> - </span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '3000'">
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                            </div>
                          </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '2000'">
                              <span>{{item_j.bonusTotalAmount}}</span>
                            </div>
                            <div v-else-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '3000'">
                              <span>{{record.bonusTotalAmount}}</span>
                              <span style="color: #4C5AFF;">({{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}})</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 其它费项 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2] && 
                           contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">其它费项</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[2] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox3' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- 物业条款 -->
              <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList.length">
                <ul style="display: flex; height: 30px; line-height: 30px; margin-top: 20px;">
                  <li v-for="(item_i,i) in contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList"
                      style="border: 1px solid #d9d9d9; padding: 0 6px;" 
                      v-bind:style="{backgroundColor: activeDetailPropertyTab == i ? '#4f84ff' : 'unset',
                                     color: activeDetailPropertyTab == i ? '#FFF' : 'unset',
                                     borderColor: activeDetailPropertyTab == i ? '#4f84ff' : '#d9d9d9',}"
                      @click="activeDetailPropertyTabFn(i)">
                    物业条款{{i+1}}
                  </li>
                </ul>
                <!-- 租赁保证金押金 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">租赁保证金押金</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[0] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox4' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;"> - </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 租金 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">
                      {{contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1][0].clauseTypeName}}
                    </h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[1] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox5' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '2000'">
                              <span> - </span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '3000'">
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                            </div>
                          </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '2000'">
                              <span>{{item_j.bonusTotalAmount}}</span>
                            </div>
                            <div v-else-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '3000'">
                              <span>{{record.bonusTotalAmount}}</span>
                              <span style="color: #4C5AFF;">({{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}})</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 其它费项 -->
                <div v-if="contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2] && 
                           contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">其它费项</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[2] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox6' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfo.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfo.bsContractHeaderVo.startDate}} - {{contractDetailInfo.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- 变更前 -->
            <div v-if="changeIndexDetail == 1" style="padding: 0 16px;">
              <!-- 租赁条款 -->
              <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList.length">
                <ul style="display: flex; height: 30px; line-height: 30px; margin-top: 20px;">
                  <li v-for="(item_i,i) in contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList"
                      style="border: 1px solid #d9d9d9; padding: 0 6px;" 
                      v-bind:style="{backgroundColor: activeDetailRentTab == i ? '#4f84ff' : 'unset',
                                     color: activeDetailRentTab == i ? '#FFF' : 'unset',
                                     borderColor: activeDetailRentTab == i ? '#4f84ff' : '#d9d9d9',}"
                      @click="activeDetailRentTabFn(i)">
                    租赁条款{{i+1}}
                  </li>
                </ul>
                <!-- 租赁保证金押金 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">租赁保证金押金</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[0] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox1' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[0]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;"> - </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 租金 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">
                      {{contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1][0].clauseTypeName}}
                    </h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[1] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox2' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[1]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '2000'">
                              <span> - </span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '3000'">
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                            </div>
                          </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '2000'">
                              <span>{{item_j.bonusTotalAmount}}</span>
                            </div>
                            <div v-else-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeMethod == '3000'">
                              <span>{{record.bonusTotalAmount}}</span>
                              <span style="color: #4C5AFF;">({{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}})</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 其它费项 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2] && 
                           contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">其它费项</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].totalNumArr[2] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox3' + '_' + changeIndexDetail + '_' + activeDetailRentTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.rentClauseDetailList[activeDetailRentTab].chargeDetailItemList[2]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- 物业条款 -->
              <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList.length">
                <ul style="display: flex; height: 30px; line-height: 30px; margin-top: 20px;">
                  <li v-for="(item_i,i) in contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList"
                      style="border: 1px solid #d9d9d9; padding: 0 6px;" 
                      v-bind:style="{backgroundColor: activeDetailPropertyTab == i ? '#4f84ff' : 'unset',
                                     color: activeDetailPropertyTab == i ? '#FFF' : 'unset',
                                     borderColor: activeDetailPropertyTab == i ? '#4f84ff' : '#d9d9d9',}"
                       @click="activeDetailPropertyTabFn(i)">
                    物业条款{{i+1}}
                  </li>
                </ul>
                <!-- 租赁保证金押金 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">租赁保证金押金</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[0] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div  :ref="'detailScrollBox4' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[0]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;"> - </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 租金 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">
                      {{contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1][0].clauseTypeName}}
                    </h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[1] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox5' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[1]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '2000'">
                              <span> - </span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '3000'">
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                              <span style="color: #4C5AFF;">({{item_j.bonusPrice}}%)</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</span>
                            </div>
                          </li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">
                            <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '2000'">
                              <span>{{item_j.bonusTotalAmount}}</span>
                            </div>
                            <div v-else-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeMethod == '3000'">
                              <span>{{record.bonusTotalAmount}}</span>
                              <span style="color: #4C5AFF;">({{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}})</span>
                            </div>
                            <div v-else>
                              <span>{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 其它费项 -->
                <div v-if="contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2] && 
                           contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2].length">
                  <div style="display: flex; justify-content: space-between;">
                    <h4 style="height: 50px; line-height: 50px; font-weight: bold;">其它费项</h4>
                    <span style="height: 50px; line-height: 50px;">
                      总金额：{{contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].totalNumArr[2] | kzmjTotalFilter}}
                    </span>
                  </div>
                  <div :ref="'detailScrollBox6' + '_' + changeIndexDetail + '_' + activeDetailPropertyTab" 
                       style="width: 100%; max-height: 300px; overflow: hidden; line-height: 20px;">
                    <ul style="width: 600px;">
                      <li>
                        <ul style="display: flex; background-color: #F8F8F8; padding: 10px 6px; border-radius: 4px;">
                          <li style="width: 20%;">租期</li>
                          <li style="width: 20%;">当期单价</li>
                          <li style="width: 20%;">应收日期</li>
                          <li style="width: 20%;">费项</li>
                          <li style="width: 20%;">总金额（元）</li>
                        </ul>
                      </li>
                      <li v-for="(item_j,j) in contractDetailInfoOld.bsChargeDetailVo.propertyClauseDetailList[activeDetailPropertyTab].chargeDetailItemList[2]"
                          style="padding: 6px;">
                        <ul style="display: flex;">
                          <li style="width: 20%;">
                            <span v-if="item_j.startDate && item_j.endDate">{{item_j.startDate}} - {{item_j.endDate}}</span>
                            <span v-else>{{contractDetailInfoOld.bsContractHeaderVo.startDate}} - {{contractDetailInfoOld.bsContractHeaderVo.endDate}}</span>
                          </li>
                          <li style="width: 20%;">{{item_j.price ? item_j.price : '-'}}{{item_j.unit | itemFilter('contract_clause_unit', allSelect)}}</li>
                          <li style="width: 20%;">{{item_j.paymentDate}}</li>
                          <li style="width: 20%;">{{item_j.clauseTypeName}}</li>
                          <li style="width: 20%;">{{item_j.totalAmount ? item_j.totalAmount : 0 | kzmjTotalFilter}}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag == 'HTBGN' && contractDetailInfo.bsContractHeaderVo.changeDescription">
          <div class="cardTitle">
            <h3>变更描述</h3>
          </div>
          <div style="border: 1px solid rgba(232, 232, 232, 1); border-radius: 4px; margin: 16px 16px 0; padding: 8px;">
            <pre style="font-size: 14px; white-space: pre-wrap;">{{ contractDetailInfo.bsContractHeaderVo.changeDescription }}</pre>
          </div>
        </div>
        <div class="card" v-if="myDataObj.bizFlag != 'HTBGN'">
          <div class="cardTitle">
            <h3>房源信息</h3>
          </div>
          <div class="houseCard">
            <div class="houseTitle">
              <span class="buildName">楼宇</span>
              <span class="floorName">楼层</span>
              <span class="houseCode">房号</span>
              <span class="area">面积(㎡)</span>
            </div>
            <div class="houseBox">
              <p
                v-for="item in myDataObj.bizFlag == 'HTTZU'
                  ? contractDetailData.bsContractSpaceList
                  : contractDetail.bsContractSpaceList"
                :key="item.id"
              >
                <span class="buildName">{{ item.buildName }}</span>
                <span class="floorName">{{ item.floorName }}</span>
                <span class="houseCode">{{ item.spaceName }}</span>
                <span class="area">{{ item.maxArea }}㎡</span>
              </p>
            </div>
          </div>
        </div>
        <div class="card" v-if="contractDetail.reasons">
          <div class="cardTitle">
            <h3>作废原因</h3>
          </div>
          <p class="cancel">{{ contractDetail.reasons }}</p>
        </div>

        <!--审批附件  gdx-->
        <div class="card" v-if="approveFileArr.length > 0">
          <div class="cardTitle">
            <h3>审批附件</h3>
          </div>
          <div class="appendixCard" v-if="sence == 1">
            <div
              v-for="item in approveFileArr"
              @click="showFilepage(item)"
              :key="item.id"
            >
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </div>
          </div>
          <div class="appendixCard" v-else>
            <a :href="item.path" v-for="item in approveFileArr" :key="item.id">
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </a>
          </div>
        </div>
        <approvalProgress :myDataObj="myDataObj"></approvalProgress>
      </div>
    </div>
    <footer v-if="edit">
      <a @click="showShadow = 2">不通过</a>
      <a @click="showShadow = 1">审批通过</a>
    </footer>
    <div v-if="showShadow" class="shadowCard">
      <div class="shadowBox">
        <h3>审批原因</h3>
        <textarea placeholder="请输入说明信息" v-model="markContent"></textarea>
        <div class="btnCard">
          <a @click="showShadow = false">取消</a>
          <a @click="doInstance(showShadow)">确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './approvalMixin' // 引入mixin文件
import BScroll from 'better-scroll'
import {
  loadOneInnstance,
  queryFeeCodeDataByCompanyIdForPage,
  loadContractInfoById,
  loadContractCalDataByContPk,
  loadContractDraftInfoForApproveByContId
} from '@/utils/api'
import { number_format } from '@/utils/common'
import wx from 'weixin-js-sdk'

export default {
  name: 'App',
  mixins: [mixin],
  data() {
    return {
      self_fee_code: {},
      contractDetailData: {
        bsContractHeaderVo: {}
      },
      contractDetail: {},
      changeIndex: 0,
      changeIndexDetail: 0,
      activeDetailRentTab: 0,
      activeDetailPropertyTab: 0,
      contractDetailInfo: {
        bsContractHeaderVo: {},
        bsChargeDetailVo: {
          rentClauseDetailList: [],
          propertyClauseDetailList: [],
        },
      },
      /*费用结算总计*/
      breakFeeGatherTotal: null,
      micromessengerUserAgent: false,
    }
  },
  created() {
    this.getApproveFileFn()
    if (window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
      this.micromessengerUserAgent = true;
    }
  },
  methods: {
    loadOneInnstance() {
      let timestamp = new Date().getTime()
      loadOneInnstance({
        userId: this.userInfo.userInfo.id,
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.$route.query.id
      }).then(res => {
        this.myDataObj = res.data
        switch (this.myDataObj.bizFlag) {
          //走退租
          case 'HTTZU':
            queryFeeCodeDataByCompanyIdForPage().then(res1 => {
              this.self_fee_code = res1.data
            })
            loadContractInfoById({
              id: this.myDataObj.bsid,
              version: JSON.parse(this.myDataObj.businessData).version
            }).then(res2 => {
              if (res2.data.bsContractHeaderVo.approveStatus == 1006) {
                this.contractDetailData = JSON.parse(JSON.stringify(res2.data))
                this.computedBreakFeeGatherTotal()
                this.$nextTick(function() {
                  let mainCard = document.querySelector('.mainCard'),
                    deductFromCard = document.querySelector('.deductFromCard')
                  this.scroll = new BScroll(mainCard, {
                    scrollY: true,
                    click: true
                  })
                  new BScroll(deductFromCard, {
                    scrollX: true,
                    click: true
                  })
                })
              } else {
                loadContractDraftInfoForApproveByContId({
                  contId: res2.data.bsContractHeaderVo.contId
                }).then(res3 => {
                  this.contractDetailData = JSON.parse(
                    JSON.stringify(res3.data)
                  )
                  this.computedBreakFeeGatherTotal()
                  if (
                    res3.data.bsContractHeaderVo.approveMethod.includes('200')
                  ) {
                    this.getApproveFileFn(
                      res3.data.bsContractHeaderVo.id,
                      res3.data.bsContractHeaderVo.id
                    )
                  }
                  this.$nextTick(function() {
                    let mainCard = document.querySelector('.mainCard'),
                      deductFromCard = document.querySelector('.deductFromCard')
                    this.scroll = new BScroll(mainCard, {
                      scrollY: true,
                      click: true
                    })
                    new BScroll(deductFromCard, {
                      scrollX: true,
                      click: true
                    })
                  })
                })
              }
            })
            break
          //走变更
          case 'HTBGN':
            loadContractInfoById({
              id: this.myDataObj.bsid,
              version: JSON.parse(this.myDataObj.businessData).version
            }).then(res4 => {
              console.log(JSON.parse(JSON.stringify(res4)));
              this.contractDetailInfo = res4.data
              this.totalbChargeDetailVoListFn(this.contractDetailInfo);
              if (res4.data.bsContractHeaderVo.approveMethod.includes('200')) {
                this.getApproveFileFn(
                  res4.data.bsContractHeaderVo.id,
                  res4.data.bsContractHeaderVo.id
                )
              }

              loadContractInfoById({
                id: this.contractDetailInfo.bsContractHeaderVo.linkContPk
              }).then(res5 => {
                console.log(JSON.parse(JSON.stringify(res5)));
                this.contractDetailInfoOld = res5.data
                this.totalbChargeDetailVoListFn(this.contractDetailInfoOld);
                this.$nextTick(function() {
                  let mainCard = document.querySelector('.mainCard')
                  this.scroll = new BScroll(mainCard, {
                    scrollY: true,
                    click: true
                  })

                  this.bsScrollFn();
                })
              })
              loadContractCalDataByContPk({
                contPk: this.myDataObj.bsid
              }).then(res6 => {
                this.contractDetail = res6.data
                this.$nextTick(function() {
                  let mainCard = document.querySelector('.mainCard')
                  this.scroll = new BScroll(mainCard, {
                    scrollY: true,
                    click: true
                  })
                })
              })
            })
            break
          default:
            loadContractCalDataByContPk({
              contPk: this.myDataObj.bsid
            }).then(res6 => {
              this.contractDetail = res6.data
              this.contractDetail.bsContractHeaderVo = {
                approveMethod: null
              }

              loadContractInfoById({
                id: this.myDataObj.bsid,
                version: JSON.parse(this.myDataObj.businessData).version
              }).then(res7 => {
                this.contractDetail.bsContractHeaderVo.approveMethod =
                  res7.data.bsContractHeaderVo.approveMethod
                this.contractDetail.keywordMapList = res7.data.keywordMapList
                if (
                  res7.data.bsContractHeaderVo.approveMethod.includes('200')
                ) {
                  this.getApproveFileFn(
                    res7.data.bsContractHeaderVo.id,
                    res7.data.bsContractHeaderVo.id
                  )
                }
              })
              this.$nextTick(function() {
                let mainCard = document.querySelector('.mainCard')
                this.scroll = new BScroll(mainCard, {
                  scrollY: true,
                  click: true
                })
              })
            })
        }
        for (let i = 0; i < res.data.taskList.length; i++)
          if (
            res.data.taskList[i].nodeType != 1 &&
            res.data.taskList[i].nodeType != 4 &&
            res.data.currentNodeId == res.data.taskList[i].nodeId &&
            res.data.subRound == res.data.taskList[i].subRound &&
            !res.data.taskList[i].itemPassMethod &&
            res.data.taskList[i].receiverId == this.userInfo.userInfo.id &&
            (res.data.approStatus == 1000 || res.data.approStatus == 3000)
          ) {
            this.edit = true
            return
          }
      })
    },
    /*计算费用结算总计*/
    computedBreakFeeGatherTotal() {
      let inputTotal = 0
      let outputTotal = 0
      let backTotal = 0
      for (
        let i = 0;
        i < this.contractDetailData.breakFeeGatherVoList.length;
        i++
      ) {
        let item = this.contractDetailData.breakFeeGatherVoList[i]
        if (item.retreat == '1') {
          inputTotal = Number(inputTotal) + Number(item.money)
        } else if (item.retreat == '2') {
          outputTotal = Number(outputTotal) + Number(item.money)
        } else if (item.retreat == '3') {
          backTotal = Number(backTotal) + Number(item.money)
        }
      }
      this.breakFeeGatherTotal =
        Number(inputTotal) - Number(outputTotal) - Number(backTotal)
    },
    /* 计算合同条款明细总金额 */
    totalbChargeDetailVoListFn(contractObj) {
      contractObj.bsChargeDetailVo.rentClauseDetailList.forEach(function(item,index) {
        item.totalNumArr = [];
        item.chargeDetailItemList.forEach((item1,index1) => {
          var totalNum = null;
          item1.forEach((item2,index2) => {
            item2.key = index2;
            totalNum += Number(item2.totalAmount ? item2.totalAmount : 0);
          });
          item.totalNumArr.push(totalNum);
        });
      });
      contractObj.bsChargeDetailVo.propertyClauseDetailList.forEach(function(item,index) {
        item.totalNumArr = [];
        item.chargeDetailItemList.forEach((item1,index1) => {
          var totalNum = null;
          item1.forEach((item2,index2) => {
            item2.key = index2;
            totalNum += Number(item2.totalAmount ? item2.totalAmount : 0);
          });
          item.totalNumArr.push(totalNum);
        });
      });
    },
    /* h5跳转小程序合同详情 */
    jumpToXcxContractDetailFn() {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') > -1) {
        wx.miniProgram.navigateTo({
          url:
            '/pages/services_htgl_details/index?id=' +
            this.myDataObj.bsid +
            '&version=' +
            JSON.parse(this.myDataObj.businessData).version
        })
      }
    },
    /* 变更前后 */
    changeIndexDetailFn(index) {
      this.changeIndexDetail = index;
      this.activeDetailRentTab = 0;
      this.activeDetailPropertyTab = 0;
    },
    /* 租赁tab */
    activeDetailRentTabFn(index) {
      this.activeDetailRentTab = index;
    },
    /* 物业tab */
    activeDetailPropertyTabFn(index) {
      this.activeDetailPropertyTab = index;
    },
    /* bs-scroll初始化 */
    bsScrollFn() {
      let refstrArr = [];
      refstrArr.push('detailScrollBox1' + '_' + this.changeIndexDetail + '_' + this.activeDetailRentTab);
      refstrArr.push('detailScrollBox2' + '_' + this.changeIndexDetail + '_' + this.activeDetailRentTab);
      refstrArr.push('detailScrollBox3' + '_' + this.changeIndexDetail + '_' + this.activeDetailRentTab);
      refstrArr.push('detailScrollBox4' + '_' + this.changeIndexDetail + '_' + this.activeDetailPropertyTab);
      refstrArr.push('detailScrollBox5' + '_' + this.changeIndexDetail + '_' + this.activeDetailPropertyTab);
      refstrArr.push('detailScrollBox6' + '_' + this.changeIndexDetail + '_' + this.activeDetailPropertyTab);
      for (let i = 0; i < refstrArr.length; i++) {
        const element = refstrArr[i];
        if (this.$refs[element]) {
          new BScroll(this.$refs[element], {
            scrollX: true,
            scrollY: true,
            stopPropagation: true,
            probeType: 2,
          })
        }
      }
    },
  },
  filters: {
    itemFeeCodeFilter: (value, feeCode) => {
      for (let index in feeCode)
        if (feeCode[index].code == value) {
          return feeCode[index].text
        }
    },
    keepTwoDecimal: num => {
      if (!num) {
        return 0
      }

      var result = parseFloat(num)
      if (isNaN(result)) {
        return 0
      }
      result = Number(result).toFixed(2)
      result = Math.round(num * 100) / 100
      return result
    },
    kzmjTotalFilter: function(value) {
      return number_format(value)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;

  header {
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 48px;

    img {
      width: 44px;
      height: 44px;
      position: absolute;
      left: 28px;
    }
  }

  .navCard {
    height: 88px;
    display: flex;

    a {
      flex: 1;
      height: 88px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 88px;
      text-align: center;
      position: relative;
    }

    .active {
      color: rgba(61, 96, 223, 1);
    }

    span {
      display: block;
      width: 40px;
      height: 6px;
      background: linear-gradient(
        270deg,
        rgba(79, 132, 255, 1) 0%,
        rgba(76, 90, 255, 1) 100%
      );
      border-radius: 4px 4px 0 0;
      position: absolute;
      bottom: 0;
      left: 106px;
    }
  }

  .mainCard {
    flex: 1;
    overflow: hidden;

    .mainBox {
      background: rgba(247, 248, 249, 1);
      padding: 20px;

      .card {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.02);
        border-radius: 16px;
        padding-bottom: 30px;
        margin-bottom: 20px;

        .cardTitle {
          height: 88px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.09);

          h3 {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.8);
            line-height: 40px;
          }

          span {
            width: 104px;
            height: 44px;
            background: rgba(255, 246, 238, 1);
            border-radius: 22px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 173, 93, 1);
            line-height: 44px;
            text-align: center;
          }

          a {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 40px;
            display: flex;

            img {
              width: 40px;
              height: 40px;
            }
          }

          .changeTitle {
            display: flex;
            // margin-top: 30px;
            // margin-left: 30px;

            a {
              width: 114px;
              height: 44px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 44px;
              text-align: center;
              background: rgba(0, 0, 0, 0.04);
              display: unset;
            }
            a:nth-child(1) {
              border-radius: 8px 0 0 8px;
            }
            a:nth-child(2) {
              border-radius: 0 8px 8px 0;
            }

            .activeChangeTitle {
              background: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1) 0%,
                rgba(76, 90, 255, 1) 100%
              );
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        p {
          display: flex;
          margin-top: 30px;
          padding: 0 30px;

          label {
            width: 120px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 34px;
            margin-right: 30px;
          }

          span {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
            line-height: 34px;
          }

          i {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 40px;
            text-align: center;
            margin-right: 10px;
          }

          .zu {
            background: rgba(0, 0, 0, 0.02);
            border: 2px solid rgba(0, 0, 0, 0.15);
            color: rgba(0, 0, 0, 0.6);
          }

          .wu {
            opacity: 0.2;
            border: 2px solid;
            border-image: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1),
                rgba(76, 90, 255, 1)
              )
              2 2;
            color: rgba(61, 96, 223, 1);
          }

          .bu {
            background: rgba(22, 188, 132, 0.1);
            border: 2px solid rgba(22, 188, 132, 0.2);
            color: rgba(22, 188, 132, 1);
          }
        }

        .box {
          display: flex;

          p {
            flex: 1;
          }
        }

        .terminateCard {
          width: 670px;
          height: 120px;
          background: rgba(247, 248, 249, 1);
          border-radius: 16px;
          margin-top: 30px;
          margin-left: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 38px;
          box-sizing: border-box;

          .terminateBox {
            display: flex;
            flex-direction: column;
            align-items: center;

            label {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.4);
              line-height: 34px;
              margin-bottom: 6px;
            }

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
              margin-top: 6px;
            }
          }
        }

        .dateCard {
          width: 670px;
          height: 120px;
          background: rgba(247, 248, 249, 1);
          border-radius: 16px;
          margin: 30px 20px 0;
          display: flex;

          .dateBox {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            label {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.4);
              line-height: 34px;
              margin-bottom: 6px;
            }

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
              margin-top: 6px;
            }
          }
        }

        .houseCard {
          padding: 20px;

          .houseTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .buildName {
            width: 256px;
          }

          .floorName {
            width: 122px;
          }

          .houseCode {
            width: 158px;
          }

          .area {
            width: 114px;
          }
        }

        .deductFromCard {
          width: 650px;
          padding: 20px 0;
          margin-left: 20px;
          overflow: hidden;

          .deductFromScroll {
            width: 900px;
          }

          .deductFromTitle {
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .offsetFeeCode {
            width: 120px;
          }

          .surplusMoney {
            width: 140px;
          }

          .offsetMoney {
            width: 140px;
          }

          .srcFeeCode {
            width: 100px;
          }

          .startDate {
            width: 300px;
          }
        }

        .changeCard {
          .changeTitle {
            display: flex;
            margin-top: 30px;
            margin-left: 30px;

            a {
              width: 114px;
              height: 44px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 44px;
              text-align: center;
              background: rgba(0, 0, 0, 0.04);
            }

            .activeChangeTitle {
              background: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1) 0%,
                rgba(76, 90, 255, 1) 100%
              );
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        .cancel {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }

        .totalCostCard {
          padding: 20px;

          .totalCostTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .circle {
            width: 200px;
          }

          .type {
            width: 96px;
          }

          .should {
            width: 120px;
          }

          .account {
            flex: 1;
          }

          .totalCostBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .sumCard {
            height: 40px;
            box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.09);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: 24px;

            h4 {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
            }

            span {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.8);
              line-height: 40px;
            }
          }
        }

        .terminateReasons {
          padding: 30px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }

        .appendixCard {
          display: flex;
          flex-direction: column;
          align-items: center;

          a,
          div {
            width: 670px;
            height: 100px;
            background: rgba(247, 248, 249, 1);
            border-radius: 16px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(61, 96, 223, 1);
            line-height: 40px;
            box-sizing: border-box;

            .approveFileBox {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: block;
            }

            span {
              display: flex;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
              }

              &:first-child {
                flex: 1;
              }

              &:last-child {
                width: 160px;
                text-align: right;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }

  footer {
    height: 112px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;

    a {
      &:first-child {
        width: 296px;
        height: 72px;
        border-radius: 40px;
        border: 1px solid rgba(61, 96, 223, 1);
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(61, 96, 223, 1);
        line-height: 72px;
        text-align: center;
      }

      &:last-child {
        width: 296px;
        height: 72px;
        background: linear-gradient(
          270deg,
          rgba(79, 132, 255, 1) 0%,
          rgba(76, 90, 255, 1) 100%
        );
        border-radius: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 72px;
        text-align: center;
      }
    }
  }

  .shadowCard {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .shadowBox {
      width: 540px;
      height: 360px;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;

      h3 {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 44px;
        margin: 40px 0;
        text-align: center;
      }

      textarea {
        width: 474px;
        height: 100px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        margin-left: 32px;
        padding: 10px;
        box-sizing: border-box;
      }

      .btnCard {
        width: 540px;
        height: 96px;
        background: rgba(245, 245, 245, 1);
        border-radius: 0px 0px 16px 16px;
        margin-top: 40px;
        display: flex;

        a {
          flex: 1;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 96px;
          text-align: center;
        }
      }
    }
  }
}
</style>
